interface UrlInfo {
  path: string;
  build: (...args: any[]) => string;
  label: string;
}

export const Urls: Record<string, UrlInfo> = {
  // IPH-01 · 대시보드
  main: {
    path: '/',
    build: () => '/',
    label: '대시보드',
  },
  // IPH-02 · PO 관리 > 전체 PO
  poAll: {
    path: '/po',
    build: () => '/po',
    label: '전체 PO',
  },
  // IPH-03 · PO 관리 > 처리 필요
  poAction: {
    path: '/po/action',
    build: () => '/po/action',
    label: '처리 필요',
  },
  // IPH-04 · PO 관리 > 상신 PO (검토자 전용)
  poSubmitted: {
    path: '/po/submitted',
    build: () => '/po/submitted',
    label: '상신 PO',
  },
  // IPH-05 · PO 관리 > 지연 PO
  poLate: {
    path: '/po/late',
    build: () => '/po/late',
    label: '지연 PO',
  },
  // IPH-06 · PO 관리 > 납기 관리
  delivery: {
    path: '/po/delivery',
    build: () => '/po/delivery',
    label: '납기 관리',
  },
  // IPH-07 · 발주 관리 > 생산 계획
  plan: {
    path: '/plan',
    build: () => '/plan',
    label: '생산 계획',
  },
  // IPH-08 · 발주 관리 > 일괄 발주
  mrp: {
    path: '/order/bulk',
    build: () => '/order/bulk',
    label: '일괄 발주',
  },
  // IPH-10 · 발주 관리 > 발주 예정
  pendingOrder: {
    path: '/order/pending',
    build: () => '/order/pending',
    label: '발주 예정',
  },
  // IPH-09 · 발주 관리 > 단품 발주
  singleOrder: {
    path: '/order/single',
    build: () => '/order/single',
    label: '단품 발주',
  },
  // IPH-11 · 구매 지표
  kpi: {
    path: '/kpi',
    build: () => '/kpi',
    label: '구매 지표',
  },
  // 데이터 점검 — ERP 적재 알림 · 값 변경 이력 (옛 이름 '운영 조회'. 경로는 그대로)
  system: {
    path: '/system',
    build: () => '/system',
    label: '데이터 점검',
  },
  // 관리자 메뉴 > 권한 관리 — IPH role 보유자 조회·부여·회수 (관리자 전용)
  rolePermission: {
    path: '/admin/roles',
    build: () => '/admin/roles',
    label: '권한 관리',
  },
  // 관리자 메뉴 > ISP 사용자 가입 승인 — 외부 협력사 포털 신청자 승인·거절 (관리자 전용)
  // 거래처의 'ISP 사용 허용'(회사 단위)과 구분된다 — 이쪽은 사용자 단위다
  externalApproval: {
    path: '/admin/external-approval',
    build: () => '/admin/external-approval',
    label: 'ISP 사용자 가입 승인',
  },
  // IPH-12 · 기준정보 > 거래처 (ISP 사용 허용 — 회사 단위)
  supplier: {
    path: '/master/suppliers',
    build: () => '/master/suppliers',
    label: '거래처',
  },
  // IPH-12 · 기준정보 > 품목 — 구매조건·단가·물류 (ERP 가 모르는 값을 채우는 자리)
  item: {
    path: '/master/items',
    build: () => '/master/items',
    label: '품목',
  },
  // IPH-12 · 기준정보 > 제조구분 — 거래처 제조구분 select 의 원천
  manufacturingType: {
    path: '/master/manufacturing-types',
    build: () => '/master/manufacturing-types',
    label: '제조구분',
  },
  // IPH-12 · 기준정보 > 직원 — 품목 담당자 명단 (ERP 미연동, 임시 수기)
  employee: {
    path: '/master/employees',
    build: () => '/master/employees',
    label: '직원',
  },
  // IPH-12 · 기준정보 > 창고 분류 — Revel2 가 MRP 제외 창고의 기준
  warehouse: {
    path: '/master/warehouses',
    build: () => '/master/warehouses',
    label: '창고 분류',
  },
  // IPH-12 · 기준정보 > 공휴일 — 영업일 계산 기준
  holiday: {
    path: '/master/holidays',
    build: () => '/master/holidays',
    label: '공휴일',
  },
  // IPH-12 · 기준정보 > 계산 파라미터 — MRP·발주 계산에 들어가는 상수
  calcParam: {
    path: '/master/calc-params',
    build: () => '/master/calc-params',
    label: '계산 파라미터',
  },
  // IPH-12 · 기준정보 > 카테고리 매핑 — ERP 카테고리 → 제품군·부품군·기본 게이트
  categoryMap: {
    path: '/master/category-maps',
    build: () => '/master/category-maps',
    label: '카테고리 매핑',
  },
  // IPH-12 · 기준정보 > BOM — 변형 분류(메인 지정) + 변형 판매 비율
  bom: {
    path: '/master/bom',
    build: () => '/master/bom',
    label: 'BOM 관리',
  },
  // IPH-12 · 기준정보 > 문서 양식 — 발주 메일·발주서·출력물 3종 버전 관리
  docTemplate: {
    path: '/master/doc-templates',
    build: () => '/master/doc-templates',
    label: '문서 양식',
  },
  // IPH-12 · 기준정보 > ERP 발주 라인 — 적재 원본 대사(PO 목록이 아니다)
  erpPoLine: {
    path: '/master/erp-po-lines',
    build: () => '/master/erp-po-lines',
    label: 'ERP 발주 라인',
  },
  // IPH-12 · 기준정보 > ERP 적재 현황 — 테이블별 기준 시각·마지막 동기화·실행 이력
  erpSync: {
    path: '/master/erp-sync',
    build: () => '/master/erp-sync',
    label: 'ERP 적재 현황',
  },
  // TODO: 페이지 URL 추가
} as const;

export type URL_KEY = keyof typeof Urls;
export type URL_VAL = (typeof Urls)[URL_KEY];
